var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcSmileyNo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.125,
    cy: 15.6875,
    r: 15,
    fill: "#D792DF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1031 12.6246C13.2603 12.1654 13.0155 11.6657 12.5563 11.5085C12.097 11.3512 11.5973 11.5961 11.4401 12.0553C11.1522 12.8965 10.3614 13.4617 9.47219 13.4617C8.58245 13.4617 7.79137 12.896 7.50379 12.054C7.34688 11.5948 6.84743 11.3495 6.38799 11.5064C5.92862 11.6633 5.68352 12.1629 5.84038 12.6222C6.371 14.1757 7.83051 15.2195 9.47219 15.2195C11.1127 15.2195 12.5719 14.1767 13.1031 12.6246ZM15.0201 17.5194C12.5627 17.5194 10.2516 18.8289 8.98862 20.937C8.73913 21.3533 8.87448 21.8932 9.29085 22.1426C9.70728 22.3922 10.247 22.2567 10.4965 21.8404C11.4437 20.2594 13.1771 19.2772 15.0201 19.2772C16.8684 19.2772 18.6043 20.2635 19.5504 21.8514C19.7148 22.1274 20.0067 22.2806 20.3062 22.2806C20.4592 22.2806 20.6143 22.2406 20.7552 22.1566C21.1722 21.9081 21.3088 21.3687 21.0604 20.9517C19.799 18.8345 17.4845 17.5194 15.0201 17.5194ZM22.5426 12.0553C22.6999 11.5961 23.1997 11.3514 23.6588 11.5085C24.118 11.6657 24.3628 12.1654 24.2056 12.6247C23.6742 14.1768 22.2151 15.2195 20.5746 15.2195C18.9329 15.2195 17.4734 14.1757 16.9428 12.6222C16.7859 12.1629 17.031 11.6633 17.4904 11.5064C17.9499 11.3495 18.4493 11.5948 18.6062 12.054C18.8937 12.896 19.6848 13.4617 20.5746 13.4617C21.4637 13.4617 22.2546 12.8965 22.5426 12.0553Z",
    fill: "#081731"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSmileyNo);
export default __webpack_public_path__ + "static/media/ic-smiley-no.f4b954cdcdbdc249f8c11f63583d2c02.svg";
export { ForwardRef as ReactComponent };